import {
  NumericFormatType,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControlType,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { TradingActivityModel } from './trading-activity.model';

export class TradingActivityConfiguration extends ReportSectionConfigurationBase {
  typeName = 'TradingActivityConfiguration';
  nodataLocalizationKeyName = 'bnyMonthlyTradingActivity';
  readonly reportSection = ReportSection.TradingActivity;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_TradingActivity];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'month',
      displayName: 'Month',
      isSelected: true,
      canConfigure: false,
      unit: 1,
      property: 'date',
      isStatic: true,
      type: ReportSectionConfigurationControlType.Date
    },
    {
      name: 'tradingActivityGridTradingVolume',
      displayName: 'DR Trading Vol',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'tradingVolume',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'tradingActivityGridAvgTradingVolume',
      displayName: 'Avg/Day DR Trading Vol',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'averageDailyTradingVolume',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'tradingActivityGridTurnover',
      displayName: 'DR Turnover Ratio, %',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'turnoverRatio',
      type: ReportSectionConfigurationControlType.Decimal,
      numericFormatType: NumericFormatType.Percentage
    },
    {
      name: 'tradingActivityGridTradingVolumeUSD',
      displayName: 'DR Dollar Trading Vol, USD',
      isSelected: true,
      canConfigure: true,
      unit: 1,
      property: 'dollarTradingVolume',
      type: ReportSectionConfigurationControlType.Number
    },
    {
      name: 'tradingActivityGridAvgTradingVolumeUSD',
      displayName: 'Avg/Day DR Dollar Trading Vol',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'averageDailyDollarTradingVolume',
      type: ReportSectionConfigurationControlType.Number
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'tradingActivity';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'Monthly DR Trading Activity';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface TradingActivityData {
  [ReportViewModelSection.BnyManagementReport_TradingActivity]: TradingActivityModel;
}
